__turbopack_context__.v({
  "drawerContent": "ContactDrawer-module-scss-module__t5huIa__drawerContent",
  "root": "ContactDrawer-module-scss-module__t5huIa__root",
  "text": "ContactDrawer-module-scss-module__t5huIa__text",
  "title": "ContactDrawer-module-scss-module__t5huIa__title",
  "trigger": "ContactDrawer-module-scss-module__t5huIa__trigger",
  "triggerFooter": "ContactDrawer-module-scss-module__t5huIa__triggerFooter",
});
